import { PrivateAPINamespace } from '../PrivateAPINamespace';
import { createPanelsError, PanelsErrorCode } from './errors';

export class PanelsNamespace extends PrivateAPINamespace {
  static readonly namespace = 'panels';

  openLanguageSupportPanel(appDefinitionId: string) {
    if (!appDefinitionId) {
      throw createPanelsError(PanelsErrorCode.EmptyApplicationDefId);
    }

    this.ps.hostAPI.editor.openLanguageSupportPanel(appDefinitionId);
  }

  openFontsUploadPanel(appDefinitionId: string) {
    if (!appDefinitionId) {
      throw createPanelsError(PanelsErrorCode.EmptyApplicationDefId);
    }

    this.ps.hostAPI.editor.openFontsUploadPanel(appDefinitionId);
  }

  openDashboardPanel(
    appDefinitionId: string,
    options: {
      url: string;
      closeOtherPanels?: boolean;
    },
  ) {
    if (!appDefinitionId) {
      throw createPanelsError(PanelsErrorCode.EmptyApplicationDefId);
    }

    return this.ps.hostAPI.editor.openDashboardPanel(appDefinitionId, options);
  }
}
